
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creator/[collection]/dropcreator",
      function () {
        return require("private-next-pages/creator/[collection]/dropcreator/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creator/[collection]/dropcreator"])
      });
    }
  